import script from "./RootSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./RootSetting.vue?vue&type=script&setup=true&lang=js"

import "./RootSetting.vue?vue&type=style&index=0&id=d1af99be&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1af99be"]])

export default __exports__